// extracted by mini-css-extract-plugin
export default {"container":"DeleteSegment_container__c1gOZ","buttons-container":"DeleteSegment_buttons-container__qSdzq"};